<template>
  <div class="wrap">
    <div class="status-wrap">
      <svg-icon :iconClass="iconClass" class="icon" />
      <div class="status-text">{{ showStatus }}</div>
    </div>
    <div class="price"><span>¥</span>{{ wxjkInfo.payment_amount }}</div>
    <div class="back" @click="handleBack">返回首页</div>
  </div>
</template>
<script>
import {
  defineComponent,
  onMounted,
  ref,
  computed,
  onBeforeUnmount,
} from "@vue/composition-api";

import { queryWxjkOrder } from "@/apis/wxjk";
import { useRouter, useStore } from "@/components/use/base";
import { WXJK_ORDER_STATUS } from "@/constants";

export default defineComponent({
  setup() {
    const router = useRouter();
    const store = useStore();

    const wxjkInfo = ref({});
    const timer = ref(null);
    const queryTime = ref(0);

    const showStatus = computed(() => {
      if (wxjkInfo.value.status === "confirmed") return "支付失败，请返回重试";
      return WXJK_ORDER_STATUS[wxjkInfo?.value.status] || "";
    });

    const initWxjk = async () => {
      const { data } = await queryWxjkOrder();
      wxjkInfo.value = data;
      const { status } = data;
      if (status === "paying") {
        queryOrderInfo();
      }
    };

    const handleBack = () => {
      router.go(-1);
      store.dispatch("fetchUserInfo");
    };

    onBeforeUnmount(() => {
      clearTimeout(timer.value);
    });

    const queryOrderInfo = async () => {
      timer.value = setInterval(async () => {
        queryTime.value++;
        const { data } = await queryWxjkOrder();
        const status = data.status;
        if (status !== "paying" || queryTime.value >= 30) {
          wxjkInfo.value = data;
          clearTimeout(timer.value);
        }
      }, 2000);
    };

    const iconClass = computed(() => {
      if (["pending", "confirmed", "paying"].includes(wxjkInfo.value.status))
        return "pay-result-unpaid-gold";
      if (["canceled", "refunding", "refund"].includes(wxjkInfo.value.status))
        return "pay-result-fail-gold";
      return "pay-result-success-gold";
    });

    onMounted(() => {
      initWxjk();
    });

    return {
      showStatus,
      iconClass,
      wxjkInfo,
      handleBack,
    };
  },
});
</script>

<style lang="less" scoped>
.wrap {
  height: 100vh;
  box-sizing: border-box;
  background: #fff;
  overflow: hidden;

  .status-wrap {
    margin: 0 auto;
    margin-top: 53px;
    text-align: center;

    .icon {
      font-size: 48px;
    }

    .status-text {
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 22px;
      text-align: center;
      margin-top: 4px;
    }
  }

  .price {
    font-weight: 600;
    font-size: 44px;
    color: #000000;
    line-height: 62px;
    text-align: center;
    margin-top: 51px;

    span {
      font-size: 30px;
      margin-right: 5px;
    }
  }

  .back {
    position: fixed;
    bottom: 51px;
    left: 34px;
    right: 34px;
    height: 41px;
    font-size: 17px;
    line-height: 41px;
    background: #fff;
    text-align: center;
    color: rgb(182, 182, 182);
    border: 1px solid rgb(182, 182, 182);
    border-radius: 20px;
  }
}
</style>
